const overrides: Record<string, string> = {
	EDGE_CX_AI: 'DashCX AI',
	INTELLIGENCE: 'Intelligence',
	VOICE_CALLING: 'Calling',
	REVENUE_OPPORTUNITIES: 'Revenue & Opportunities',
	TICKETS_BOT: 'Tickets',
	WEBHOOKS: 'Webhooks',
	SIGNALS: 'Signals',
}
const toTileCase = (text: string) => {
	if (overrides[text]) return overrides[text]
	return text
		.split('_')
		.join(' ')
		.replace(/\w\S*/g, txt => {
			return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
		})
}

export default toTileCase
